<h1 class="text-2xl md:text-3xl font-bold text-gray-900">Join for free</h1>
<p class="text-gray-500 mt-1 mb-8">The automation stack your ops team actually loves.</p>

<form [formGroup]="signupForm">
  <div class="dm-input">
    <label>Your name</label>
    <input formControlName="name" type="text" placeholder="Jane Doe">
    <small class="red" *ngIf="name.touched && name.invalid">Required</small>
  </div>
  <div class="dm-input">
    <label>Email address</label>
    <input formControlName="email" type="email" placeholder="you@company.com">
    <small class="red" *ngIf="email.touched && email.invalid">Must be a valid email</small>
  </div>
  <div class="dm-input">
    <label>Password</label>
    <input formControlName="password" type="password" placeholder="••••••••">
    <small class="red" *ngIf="password.touched && password.invalid">At least 8 characters</small>
  </div>

  <button (click)="onSignup()" *ngIf="!processing" class="btn btn-primary w-full" type="button">Create account</button>
  <button class="btn btn-processing w-full" disabled *ngIf="processing" type="button">
    <i class="fas fa-circle-notch"></i>
    Processing...
  </button>

  <app-warning-message type="error" title="Sign up failed" message="Wrong email or password."
                        *ngIf="authSvc.invalidEmail || authSvc.wrongCredentials || authSvc.userNotFound"></app-warning-message>
  <app-warning-message type="error" title="Too many attempts" message="We have detected too many failed attempts. Wait a few minutes and try again."
                        *ngIf="authSvc.tooManyRequests"></app-warning-message>
  <app-warning-message type="error" title="Account already exists" message="This email account is already in use."
                        *ngIf="authSvc.alreadyInUse"></app-warning-message>
  <app-warning-message type="error" title="Something went wrong" [message]="authSvc.unknownError"
                        *ngIf="authSvc.unknownError"></app-warning-message>

  <div class="divider-new version-2 my-6 text-gray-500 flex items-center justify-center flex-row">
    <h6 class="small mx-2">OR</h6>
  </div>

  <div class="flex flex-col gap-3">
    <app-social-signin-button provider="google" label="Continue with Google" (clicked)="authSvc.loginWithSocial('google.com')"></app-social-signin-button>
    <app-social-signin-button provider="microsoft" label="Continue with Microsoft" (clicked)="authSvc.loginWithSocial('microsoft.com')"></app-social-signin-button>
  </div>

  <p class="text-sm text-gray-500 mt-8 text-center">
    <span class="mr-1">Already have an account?</span>
    <a class="basic-link font-medium" routerLink="../login">Login</a>
  </p>
</form>
